import { ListItem, Skeleton, Stack } from "@skailer-com/uikit";

export function TimeOffHistoryLoadingSkeleton() {
  return (
    <Stack gap={"md"}>
      <Stack gap={"sm"}>
        <Skeleton className={"w-28 h-4 rounded-b-md"}></Skeleton>
        <Skeleton className={"w-20 h-6 rounded-b-md"}></Skeleton>
        <Skeleton className={"w-48 h-3 rounded-b-md"}></Skeleton>
      </Stack>
      <Skeleton className={"w-20 h-7 rounded-b-md"}></Skeleton>
      <Stack className={"bg-dark/5"}>
        <Stack direction={"horizontal"} className={"h-48"} justify={"between"} items={"end"}>
          {Array.from(Array(12).keys()).map((_, i) => (
            <div className={`bg-dark/5 w-8 h-${25 + i}`} key={`skeleton_${i}`}></div>
          ))}
        </Stack>
      </Stack>
      <Skeleton className={"h-14 rounded-b-md"}></Skeleton>
      <Skeleton className={"h-14 rounded-b-md"}></Skeleton>
      <Stack>
        <Stack gap={"sm"}>
          <Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>
          <Skeleton className={"w-48 h-3 rounded-b-md"}></Skeleton>
        </Stack>
        <ListItem
          titleSlot={<Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>}
          valueSlot={<Skeleton className={"w-10 h-3 rounded-b-md"}></Skeleton>}
        ></ListItem>
        <ListItem
          titleSlot={<Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>}
          valueSlot={<Skeleton className={"w-10 h-3 rounded-b-md"}></Skeleton>}
        ></ListItem>
        <ListItem
          titleSlot={<Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>}
          valueSlot={<Skeleton className={"w-10 h-3 rounded-b-md"}></Skeleton>}
        ></ListItem>
      </Stack>
      <Stack>
        <Stack gap={"sm"}>
          <Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>
          <Skeleton className={"w-48 h-3 rounded-b-md"}></Skeleton>
        </Stack>
        <ListItem
          titleSlot={<Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>}
          valueSlot={<Skeleton className={"w-10 h-3 rounded-b-md"}></Skeleton>}
        ></ListItem>
        <ListItem
          titleSlot={<Skeleton className={"w-20 h-4 rounded-b-md"}></Skeleton>}
          valueSlot={<Skeleton className={"w-10 h-3 rounded-b-md"}></Skeleton>}
        ></ListItem>
      </Stack>
    </Stack>
  );
}
